<button mat-fab
        class="support-button"
        matTooltip="Take me to the support page to use the chatbot for help."
        (click)="openSupportPage()">
  <mat-icon><span class="material-icons-outlined">chat_bubble_outline</span></mat-icon>
</button>